import { render, staticRenderFns } from "./AppliedCandidate.vue?vue&type=template&id=2d4c107b&"
import script from "./AppliedCandidate.vue?vue&type=script&lang=js&"
export * from "./AppliedCandidate.vue?vue&type=script&lang=js&"
import style0 from "./AppliedCandidate.vue?vue&type=style&index=0&id=2d4c107b&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports